/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getRooms } from 'app/entities/room/room.reducer';
import { ChargeType } from 'app/shared/model/enumerations/charge-type.model';
import { createEntity, getEntity, reset, updateEntity } from './bed.reducer';

export const BedUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const rooms = useAppSelector(state => state.room.entities);
  const bedEntity = useAppSelector(state => state.bed.entity);
  const loading = useAppSelector(state => state.bed.loading);
  const updating = useAppSelector(state => state.bed.updating);
  const updateSuccess = useAppSelector(state => state.bed.updateSuccess);
  const chargeTypeValues = Object.keys(ChargeType);

  const handleClose = () => {
    navigate(`/bed${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getRooms({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.dateClosed !== undefined && typeof values.dateClosed !== 'number') {
      values.dateClosed = Number(values.dateClosed);
    }
    if (values.modifiedTime !== undefined && typeof values.modifiedTime !== 'number') {
      values.modifiedTime = Number(values.modifiedTime);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.charge !== undefined && typeof values.charge !== 'number') {
      values.charge = Number(values.charge);
    }

    const entity = {
      ...bedEntity,
      ...values,
      room: rooms.find(it => it.id.toString() === values.room?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          chargeType: 'HOURLY',
          ...bedEntity,
          room: bedEntity?.room?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.bed.home.createOrEditLabel" data-cy="BedCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.bed.home.createOrEditLabel">Create or edit a Bed</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="bed-id"
                  label={translate('tinyMedicRestApp.bed.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField label={translate('tinyMedicRestApp.bed.name')} id="bed-name" name="name" data-cy="name" type="text" />
              <ValidatedField
                label={translate('tinyMedicRestApp.bed.bedNumber')}
                id="bed-bedNumber"
                name="bedNumber"
                data-cy="bedNumber"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bed.tempClosed')}
                id="bed-tempClosed"
                name="tempClosed"
                data-cy="tempClosed"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bed.dateClosed')}
                id="bed-dateClosed"
                name="dateClosed"
                data-cy="dateClosed"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bed.description')}
                id="bed-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bed.modifiedBy')}
                id="bed-modifiedBy"
                name="modifiedBy"
                data-cy="modifiedBy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bed.modifiedTime')}
                id="bed-modifiedTime"
                name="modifiedTime"
                data-cy="modifiedTime"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bed.createdBy')}
                id="bed-createdBy"
                name="createdBy"
                data-cy="createdBy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bed.microSec')}
                id="bed-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bed.timestampentry')}
                id="bed-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bed.lastupdated')}
                id="bed-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bed.cursor')}
                id="bed-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bed.active')}
                id="bed-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField label={translate('tinyMedicRestApp.bed.charge')} id="bed-charge" name="charge" data-cy="charge" type="text" />
              <ValidatedField
                label={translate('tinyMedicRestApp.bed.chargeType')}
                id="bed-chargeType"
                name="chargeType"
                data-cy="chargeType"
                type="select"
              >
                {chargeTypeValues.map(chargeType => (
                  <option value={chargeType} key={chargeType}>
                    {translate(`tinyMedicRestApp.ChargeType.${chargeType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.bed.allotted')}
                id="bed-allotted"
                name="allotted"
                data-cy="allotted"
                check
                type="checkbox"
              />
              <ValidatedField
                id="bed-room"
                name="room"
                data-cy="room"
                label={translate('tinyMedicRestApp.bed.room')}
                type="select"
                required
              >
                <option value="" key="0" />
                {rooms
                  ? rooms.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/bed" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BedUpdate;
